export const thunkTypes = {
  LOAD_CUSTOMER: `kyc/loadCustomer`,
  LIST_CAPTURES: `kyc/listCaptures`,
  UPLOAD_CAPTURE: `kyc/uploadCapture`,
  REMOVE_CAPTURE: `kyc/removeCapture`,
};
